import { styles } from "./baseFormStyles";
import { FormControl } from "@ecco/ui/form-control";
import { FormLabel } from "@ecco/ui/form-label";
import { Field } from "formik";

import {
    SelectDropdown,
    SelectDropdownButton,
    SelectDropdownItem,
    SelectDropdownList,
} from "@ecco/ui/select-dropdown";
import { useEffect, useState } from "react";

interface TimeslotSelectorProps {
    header: string;
    prefix: string;
    testId: string;
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
    dropdownStyle?: object;
    initialValue?: string;
    options: {
        [key: string]: string;
    };
}

const TimeSlotDropdown = ({
    setFieldValue,
    fieldName,
    testId,
    styleButton,
    initialValue,
    options,
}) => {
    const timeSlots = Object.keys(options).map((key) => ({
        value: options[key],
        name: options[key],
    }));
    const [selectedValue, setSelectedValue] = useState(null);
    useEffect(() => {
        const initialSlot = timeSlots.find((slot) => slot.value == initialValue);
        if (initialSlot) {
            setSelectedValue(initialSlot.name);
        } else if (timeSlots && timeSlots.length > 0) {
            updateDropdown(timeSlots[0].value, timeSlots[0].name);
        }
    }, []);
    const updateDropdown = (value, name) => {
        setSelectedValue(name);
        setFieldValue(fieldName, value);
    };
    const dropdownItems = timeSlots.map((slot) => (
        <SelectDropdownItem
            data-testid={testId}
            value={slot.value}
            key={slot.name}
            onClick={() => updateDropdown(slot.value, slot.name)}
        >
            {slot.name}
        </SelectDropdownItem>
    ));
    return (
        <SelectDropdown matchWidth flip={false} placement={"top"} variant="filled">
            {({ isOpen }) => (
                <>
                    <SelectDropdownButton
                        data-testid={testId}
                        role="button"
                        w={["100%", "100%"]}
                        h={["100%", "initial"]}
                        borderColor={"gray.400"}
                        fontSize={"desktopBodyTextSmall"}
                        textAlign="start"
                        sx={styleButton}
                    >
                        {selectedValue}
                    </SelectDropdownButton>
                    {isOpen && (
                        <SelectDropdownList data-testid={testId} scrollHeight={300}>
                            {dropdownItems}
                        </SelectDropdownList>
                    )}
                </>
            )}
        </SelectDropdown>
    );
};

const TimeslotSelector = ({
    header,
    prefix,
    testId,
    setFieldValue,
    dropdownStyle,
    initialValue,
    options,
}: TimeslotSelectorProps) => {
    const fieldName = prefix + "timeslot";
    return (
        <FormControl isInvalid={false} isRequired isReadOnly={false}>
            <FormLabel htmlFor={fieldName} sx={styles.formLabel}>
                {header}
            </FormLabel>
            <Field
                testId={testId}
                as={TimeSlotDropdown}
                type="select"
                setFieldValue={setFieldValue}
                fieldName={fieldName}
                title={"Title test"}
                styleButton={dropdownStyle}
                sx={styles.formInput}
                initialValue={initialValue}
                options={options}
            />
        </FormControl>
    );
};

export default TimeslotSelector;
